/**
 * An Activity log as a CSV — the Activity block's ⋯ Export
 * (docs/majik/PROTOTYPE-DECISIONS.md → Client page): when, what, who it went
 * to or came from, what drove it, and the message itself.
 */
import { csvLine } from '../mcp/exports.ts'
import type { TimelineEntry } from './timeline.ts'

function statusOf(entry: TimelineEntry): string {
  if (!entry.body) return ''
  if (entry.body.kind === 'text_in') return 'Received'
  return entry.wouldSend ? 'Would send (Go live is off)' : 'Sent'
}

export function timelineCsv(entries: readonly TimelineEntry[]): string {
  const head = ['When', 'What', 'To or from', 'Details', 'Message', 'Status']
  return [
    csvLine(head),
    ...entries.map((e) =>
      csvLine([
        e.whenText,
        e.title,
        e.party,
        e.note,
        e.body ? [e.body.subject, e.body.text].filter(Boolean).join(' — ') : '',
        statusOf(e),
      ]),
    ),
  ].join('')
}
